
export const sortByNameInAlphabeticalOrder = (arr, prop = 'name') => {

    // Function allows to sort objects in array in alphabetical order by any property
    // if its name passed as the second param. Default is sorting by "name" prop

    if(typeof prop !== 'string') {
        return arr;
    }

    if(!Array.isArray(arr)) {
        return arr;
    } else {
        const checkValuesToBeComparable = (...values) => {
            return values.reduce((res, v) => {
                if(!res) {
                    return res;
                }
                return !!(typeof v === 'object' && v !== null && Object.prototype.hasOwnProperty.call(v, prop));
            }, true);
        };
        return arr.sort((a, b) => checkValuesToBeComparable(a, b) ? a[prop].localeCompare(b[prop]) : 0);
    }
};


/**
* Custom string sort function for React Table.
*
* Performs a natural, case-insensitive, locale-aware sort.
* Useful for strings containing numbers or special characters,
* like IDs (e.g., "A_1095", "item2", "Supervisor").
*
* @param rowA - First row object from React Table
* @param rowB - Second row object from React Table
* @param columnId - The column accessor key to sort by
* @returns -1 if A < B, 1 if A > B, 0 if equal
*/
export const sortByMixedString = (rowA, rowB, columnId) => {
    const a = rowA.values[columnId];
    const b = rowB.values[columnId];

    // Handle null/undefined
    if (a == null && b == null) return 0;
    if (a == null) return 1;
    if (b == null) return -1;

    // Locale-aware, case-insensitive, numeric sort
    return a.localeCompare(b, undefined, {
        numeric: true,
        sensitivity: 'base'
    });
};
